import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppService {

  public initTagManager(idClient) {
    const headAppend = document.createElement('script');
    headAppend.type = 'text/javascript';
    // tslint:disable-next-line:max-line-length
    headAppend.innerHTML = `(function(w,d,s,l,i){
      w[l]=w[l]||[];w[l].push({
        'gtm.start': new Date().getTime(),
        event:'gtm.js'
      });
        var f=d.getElementsByTagName(s)[0],
         j=d.createElement(s),
         dl=l!='dataLayer'?'&l='+l:'';
         j.async=true;
         j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
         })(window,document,'script','dataLayer','${idClient}');`;

    document.getElementsByTagName('head')[0].appendChild(headAppend);
    setTimeout(() => {
      const bodyAppend = document.createElement('noscript');
      const iframeAppend = document.createElement('iframe');
      iframeAppend.src = `https://www.googletagmanager.com/ns.html?id=${idClient}`;
      iframeAppend.height = '0';
      iframeAppend.width = '0';
      iframeAppend.style.cssText = 'display:none;visibility:hidden';
      bodyAppend.appendChild(iframeAppend);
      document.getElementsByTagName('body')[0].insertBefore(bodyAppend, document.getElementsByTagName('body')[0].firstChild);
    }, 1000);
  }

  public initPrivallyCookie(pidId: string) {
    const headAppend = document.createElement('script');
    headAppend.type = 'text/javascript';
    headAppend.id = 'PrivallyApp';
    headAppend.src = 'https://app.privally.global/app.js';
    headAppend.async = true;
    headAppend.setAttribute('pid', pidId);
    document.getElementsByTagName('head')[0].appendChild(headAppend);
  }

}
